class LineItem {
  constructor(params) {
    /**
     * @type {Product}
     */
    this.product = params.product;

    /**
     * @type {Number}
     */
    this.quantity = params.quantity;
  }

  get quantityDiscount() {
    const quantityDiscount = this.product.quantityDiscounts.find(d => this.quantity >= d.minQuantity && this.quantity <= d.maxQuantity);

    return quantityDiscount ? quantityDiscount.amountPerItem : 0;
  }

  get unitPrice() {
    return this.product.price - this.quantityDiscount;
  }

  get price() {
    return this.unitPrice * this.quantity;
  }
}

export default LineItem;